import type { RemainingItemsDetailsT } from '../../modernization-common/side-panel-m4/types';
import { REMAINING_ITEM_OBJECT, RemainingItemsErrorType } from '../../modernization-common/side-panel-m4/types';
import type { QaCheckFormattedError } from './error';
import { QaCheckErrorCode } from './error';
export const createRemainingItemFromQAError = (error: QaCheckFormattedError): RemainingItemsDetailsT[] => {
  switch (error.code) {
    case QaCheckErrorCode.missingFields:
      {
        return [{
          id: error.code,
          type: 'ERROR',
          label: error.name,
          objectType: REMAINING_ITEM_OBJECT.RULE_ENGINE,
          errorType: RemainingItemsErrorType.RULE_ENGINE,
          message: `Rule failed due to missing values with error - ${error.message}`
        }];
      }
    case QaCheckErrorCode.invalidRuleResponse:
      {
        return [{
          id: error.code,
          label: error.name,
          type: 'ERROR',
          objectType: REMAINING_ITEM_OBJECT.RULE_ENGINE,
          errorType: RemainingItemsErrorType.RULE_ENGINE,
          message: `Rule return non boolean response with error - ${error.message}`
        }];
      }
    case QaCheckErrorCode.unimplemented:
      {
        return [{
          id: error.code,
          label: error.name,
          type: 'ERROR',
          objectType: REMAINING_ITEM_OBJECT.RULE_ENGINE,
          errorType: RemainingItemsErrorType.RULE_ENGINE,
          message: `Invalid rule with error - ${error.message}`
        }];
      }
  }
};